<section class="pricing-table">
  <div class="container">
      <div class="center">
          <h2>Bảng giá</h2>
      </div>
      <div class="pricing-area text-center">
          <div class="row">
              <div class="col-sm-4 plan price red wow fadeInDown">
                  <ul class="list-group">
                      <li class="list-group-item heading">
                          <h1><strong>STARTER</strong><br /></h1><span class="price">100.000/Tháng</span></li>
                      <li class="list-group-item"><span>Tính năng giới hạn</span></li>
                      <li class="list-group-item"><span>Báo cáo cơ bản</span></li>
                      <li class="list-group-item"><span>Không log file</span></li>
                      <li class="list-group-item"><span>2 User</span></li>
                      <li class="list-group-item"><span>1 cửa hàng</span></li>
                      <li class="list-group-item"><span>Dành cho người bắt đầu kinh doanh</span></li>
                      <li class="list-group-item plan-action" style="display: none;"><a class="btn" href="http://azkho.com/signup.do?ID=QH100" style="/*display: none;*/">Đăng kí</a></li>
                  </ul>
              </div>
              <div class="col-sm-4 plan price green wow fadeInDown">
                  <ul class="list-group">
                      <li class="list-group-item heading">
                          <h1><strong>PROFESSIONAL</strong><br /></h1><span class="price">220.000/Tháng</span></li>
                      <li class="list-group-item"><span>Không giới hạn tính năng</span></li>
                      <li class="list-group-item"><span>Báo cáo đầy đủ</span></li>
                      <li class="list-group-item"><span>Có log file</span></li>
                      <li class="list-group-item"><span>Giới hạn User</span></li>
                      <li class="list-group-item"><span>1 cửa hàng</span></li>
                      <li class="list-group-item"><span>Kinh doanh chuyên nghiệp</span></li>
                      <li class="list-group-item plan-action" style="display: none;"><a class="btn" href="http://azkho.com/signup.do?ID=QH100">Đăng kí</a></li>
                  </ul>
              </div>
              <div class="col-sm-4 plan price yellow wow fadeInDown">
                  <ul class="list-group">
                      <li class="list-group-item heading">
                          <h1><strong>ENTERPRISE</strong><br /></h1><span class="price">800.000/Tháng</span></li>
                      <li class="list-group-item"><span>Không giới hạn tính năng</span></li>
                      <li class="list-group-item"><span>Báo cáo đầy đủ</span></li>
                      <li class="list-group-item"><span>Có log file</span></li>
                      <li class="list-group-item"><span>Không giới hạn</span></li>
                      <li class="list-group-item"><span>Được nâng cấp theo yêu cầu</span></li>
                      <li class="list-group-item"><span>Công ty, doanh nghiệp</span></li>
                      <li class="list-group-item plan-action" style="display: none;"><a class="btn" href="http://azkho.com/signup.do?ID=QH100">Đăng kí</a></li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</section>
